import React, { useState } from 'react';
import { Stepper, GetInfo } from '@operations/shared';
import { RequestEarlySettlement } from './RequestEarlySettlement';
import { getUserDiscountsApi } from '../../utils/apisConsts';

export const ViewRequestEarlySettlement: React.FC = () => {
    const [componentSteps] = useState([
        {
            title: 'Get User',
            content: <GetInfo apiLink={getUserDiscountsApi} isApplyingPhoneAndID/>,
            id: 0,
        },
        {
            title: 'Request Early Settlement',
            content: <RequestEarlySettlement />,
            id: 1,
        },
    ]);

    return (
        <>
            <Stepper componentSteps={componentSteps} />
        </>
    );
};

